import React from 'react';

interface QuantityBadgeProps {
  quantity: number;
  onClick?: (e: React.MouseEvent) => void;
  highlightZero?: boolean;
  position?: 'top-right' | 'bottom-right';
}

export const QuantityBadge: React.FC<QuantityBadgeProps> = ({
  quantity,
  onClick,
  highlightZero = false,
  position = 'top-right',
}) => {
  const isZero = quantity === 0;
  const isNegative = quantity === -1; // Don't want to restock
  const shouldHighlight = highlightZero && isZero;
  
  const positionStyles: React.CSSProperties = position === 'top-right'
    ? { top: '6px', right: '6px' }
    : { bottom: '6px', right: '6px' };

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      style={{
        position: 'absolute',
        ...positionStyles,
        minWidth: '28px',
        height: '28px',
        padding: '0 8px',
        borderRadius: '14px',
        border: 'none',
        background: isNegative
          ? 'rgba(156, 163, 175, 0.95)' // Gray for -1
          : shouldHighlight 
            ? 'var(--color-warning)' 
            : 'var(--color-bg-tertiary)',
        color: isNegative ? 'var(--color-text-inverse)' : (shouldHighlight ? 'var(--color-text-inverse)' : 'var(--color-text-primary)'),
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
        zIndex: 10,
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
      }}
      onMouseDown={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(0.95)';
      }}
      onMouseUp={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
      }}
    >
      {quantity}
    </button>
  );
};
